'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n'], ['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  margin: 20px;\n  padding: 5px;\n  width: calc(25% - 52px);\n  box-shadow: 5px 5px 5px gray;\n  transform: none;\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n\n  &.grid-cols-2 {width: calc(50% - 52px);}\n  &.grid-cols-3 {width: calc(75% - 52px);}\n  &.grid-cols-4 {width: calc(100% - 52px);}\n\n  @media (max-width: 1024px) {\n    width: calc(33% - 52px);\n    &.grid-cols-2 {width: calc(66% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 782px) {\n    width: calc(50% - 52px);\n    &.grid-cols-2 {width: calc(50% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 415px), (max-height: 415px) {\n    width: calc(100vw - 52px);\n    &.grid-cols-2 {width: calc(100% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  margin: 20px;\n  padding: 5px;\n  width: calc(25% - 52px);\n  box-shadow: 5px 5px 5px gray;\n  transform: none;\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n\n  &.grid-cols-2 {width: calc(50% - 52px);}\n  &.grid-cols-3 {width: calc(75% - 52px);}\n  &.grid-cols-4 {width: calc(100% - 52px);}\n\n  @media (max-width: 1024px) {\n    width: calc(33% - 52px);\n    &.grid-cols-2 {width: calc(66% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 782px) {\n    width: calc(50% - 52px);\n    &.grid-cols-2 {width: calc(50% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 415px), (max-height: 415px) {\n    width: calc(100vw - 52px);\n    &.grid-cols-2 {width: calc(100% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GridSizer = _styledComponents2.default.div(_templateObject);
var Card = _styledComponents2.default.div(_templateObject2);

var GiftCardsList = function (_Component) {
  _inherits(GiftCardsList, _Component);

  function GiftCardsList() {
    _classCallCheck(this, GiftCardsList);

    return _possibleConstructorReturn(this, (GiftCardsList.__proto__ || Object.getPrototypeOf(GiftCardsList)).apply(this, arguments));
  }

  _createClass(GiftCardsList, [{
    key: 'render',
    value: function render() {
      var masonryOptions = {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPostion: 'true',
        resize: 'true',
        disableImagesLoaded: true,
        updateOnEachImageLoad: false
      };
      var thanks = _react2.default.createElement(
        Card,
        { className: 'grid-item grid-cols-4' },
        _react2.default.createElement(
          'h1',
          null,
          'Thanks for your Discount Coupons purchase!'
        )
      );
      var instructions = this.props.instructions ? _react2.default.createElement(Card, { className: 'grid-item grid-cols-2', dangerouslySetInnerHTML: { __html: this.props.instructions } }) : "";
      var giftCards = this.props.giftCards.map(function (giftCard) {
        return _react2.default.createElement(
          Card,
          { className: 'grid-item grid-cols-1' },
          _react2.default.createElement('img', { src: giftCard.image, alt: giftCard.terms })
        );
      });
      return _react2.default.createElement(
        _reactMasonryComponent2.default,
        { options: masonryOptions },
        _react2.default.createElement(GridSizer, { className: 'grid-sizer' }),
        thanks,
        instructions,
        giftCards
      );
    }
  }]);

  return GiftCardsList;
}(_react.Component);

exports.default = GiftCardsList;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/gift-cards/gift-cards-list.js
// module id = 1367
// module chunks = 0